var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63329 14.6663H7.36663C7.25617 14.6663 7.16663 14.5768 7.16663 14.4663V4.66634H5.14947C4.97129 4.66634 4.88205 4.45091 5.00805 4.32492L7.85854 1.47443C7.93664 1.39632 8.06328 1.39632 8.14138 1.47443L10.9919 4.32492C11.1179 4.45091 11.0286 4.66634 10.8505 4.66634H8.83329V14.4663C8.83329 14.5768 8.74375 14.6663 8.63329 14.6663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download-arrow.35d192808a41896a329b04edb568f39f.svg";
export { ForwardRef as ReactComponent };